import { getFieldFromFactory } from 'libs/fields-manager/src/shared/factories/FieldFactory';
import { AllFormFieldModelsType } from 'libs/fields-manager/src/shared/types/FieldModelTypes';

import { ActionConfigType } from '@nw/shared/data-access';

class SectionConfig {
  sectionNameEnum: string;
  title: string;
  description: string;
  nextSectionNameEnum: string | undefined;
  prevSectionNameEnum: string | undefined | null;
  completionPercentage: number;
  fields: AllFormFieldModelsType[];
  sectionType: string;
  sectionId: string;
  sectionActionConfigs: ActionConfigType;
  formId?: string;
  productCode?: string;
  extraConfig?: string;
  parentSectionDetails?: {
    title: string;
    description: string;
    nameEnum: string;
  };

  constructor(sectionDetailsConfig: any) {
    const {
      sectionNameEnum,
      title,
      description,
      nextSectionId,
      previousSectionId,
      fields,
      sectionType,
      completionPercentage,
      sectionId,
      sectionActionConfigs,
      formId,
      productCode,
      extraConfig,
      parentSectionDetails
    } = sectionDetailsConfig;

    this.sectionId = sectionId;
    this.sectionNameEnum = sectionNameEnum;
    this.title = title;
    this.description = description;
    this.nextSectionNameEnum = nextSectionId;
    this.prevSectionNameEnum = previousSectionId;
    this.sectionType = sectionType;
    this.completionPercentage = completionPercentage;
    this.fields = fields ? this.getSectionFieldsModel(fields) : [];
    this.sectionActionConfigs = sectionActionConfigs;
    this.formId = formId;
    this.productCode = productCode;
    this.extraConfig = extraConfig;
    this.parentSectionDetails = parentSectionDetails;
  }

  getSectionFieldsModel(allFields: any[]) {
    return allFields.map((field: any) => {
      return getFieldFromFactory(field, null);
    });
  }
}

export default SectionConfig;
